import { createSelector } from '@reduxjs/toolkit'

import type { RootState } from '../store'
import { notificationsAdapter } from './notificationsSlice'

const { selectAll } = notificationsAdapter.getSelectors<RootState>(state => state.notifications)

export const selectNotifications = createSelector([selectAll], notifications => {
  for (let i = 0; i < notifications.length; i++) {
    for (let j = i + 1; j < notifications.length; j++) {
      if (notifications[i].taskId === notifications[j].taskId) {
        notifications[i] = { ...notifications[i], autoClose: 1 }
      }
    }
  }
  return notifications
})
